const types = {
  FETCHPASSAGEPASSVALIDATION: "FETCHPASSAGEPASSVALIDATION",
  EDITPASSAGEPASSVALIDATION: "EDITPASSAGEPASSVALIDATION",
  CREATEPASSAGEPASSVALIDATION: "CREATEPASSAGEPASSVALIDATION",
  CHECK_RATE_CONFLICTS: "CHECK_RATE_CONFLICTS",
  EXPORT_PASSAGEPASS_RATES_SUCCESS: "EXPORT_PASSAGEPASS_RATES_SUCCESS",
};
export default types;
